import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/shared/table/pagination/Pagination';
import { nextTasksPageAction, prevTasksPageAction, setTasksPageSizeAction } from '../../redux/actions/tasksActions';

const TasksPagination = () => {
  const pageable = useSelector((state) => state.tasks?.pageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextTasksPageAction}
      onPrevPageClickAction={prevTasksPageAction}
      onPageSizeChangeAction={setTasksPageSizeAction}
    />
  );
};

export default TasksPagination;
